import { render } from "./specialF.vue?vue&type=template&id=615f9990&scoped=true"
import script from "./specialF.vue?vue&type=script&lang=js"
export * from "./specialF.vue?vue&type=script&lang=js"

import "./specialF.vue?vue&type=style&index=0&id=615f9990&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615f9990"]])

export default __exports__